"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.anyResource = void 0;

var anyResource = function anyResource(i18n) {
  return {
    id: null,
    name: i18n.anyResourceHeader,
    specialty: i18n.anyResourceBody
  };
};

exports.anyResource = anyResource;